<template>
  <div>
    <div class="page-header d-flex">
      <h4 class="page-title">
        <i class="fas fa-layer-group"></i>
        Credit History
      </h4>
      <ul class="breadcrumbs ml-auto">
        <li class="nav-home mr-1">
          <a href="#">
            <i class="fas fa-home text-muted"></i>
          </a>
        </li>
        <li class="nav-item">
          <a class="font_15" href="#">History</a>
        </li>
        <li class="separator">
          <i class="flaticon-right-arrow"></i>
        </li>
        <li class="nav-item">
          <a class="font_15 font-weight-bold" href="#">Credit</a>
        </li>
      </ul>
    </div>
    <b-row>
      <b-col lg="12" xl="12">
        <b-card>
          <div class="d-flex flex-wrap align-items-center">
            <div class="title mr-auto">
              payment Info
            </div>
            <div class="mb7">
              <span class="float-right">[{{model.apply_date}}]{{model.created_at | datetime}}</span>
            </div>
          </div>
          <hr>
          <b-row>
            <b-col md="4">
              <b-form-group>
                <label for="ph_partner_name">Partner Name</label>
                <b-form-input v-if="model && model.partner" type="text" id="ph_partner_name" v-model="model.partner.username" :disabled="lock"></b-form-input>
                <b-button block variant="primary" @click="$router.push({ name :'partner', params : { id : model.partner.id } })"> Detail </b-button>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group>
                <label for="ph_group_name">Group Name(*)</label>
                <b-form-input v-if="model && model.group" type="text" id="ph_group_name" v-model="model.group.groupname" :disabled="lock"></b-form-input>
                <b-button block variant="primary" @click="$router.push({ name :'group', params : { id : model.group.id } })"> Detail </b-button>
              </b-form-group>
            </b-col>
            <b-col md="2">
              <b-form-group label="Payment Issue" label-for="ph_is_failed" v-b-tooltip.hover title="payment failed status">
                <c-switch color="danger" label size="sm" id="ph_is_failed" v-model="model.is_failed" :disabled="lock" />
              </b-form-group>
            </b-col>
            <b-col md="2">
              <b-form-group label="Pay Retry" label-for="ph_retry" v-b-tooltip.hover title="try to pay count">
                <b-form-input md=12 type="text" id="ph_retry" v-model="model.retry" :disabled="lock"></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <hr>
          <b-row>
            <b-col md="3">
              <b-form-group label="Refund Status" label-for="ph_is_refunded" v-b-tooltip.hover title="refunded status">
                <c-switch color="warning" label size="sm" id="ph_is_refunded" v-model="model.is_refunded" :disabled="lock" />
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group label="Refund Date" label-for="ph_refund_at" v-b-tooltip.hover title="Refund Date when happen refund">
                {{model.refund_at | datetime}}
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group label="Refund Amount" label-for="ph_refund_price" v-b-tooltip.hover title="Refund status">
                <b-input-group md=12 prepend="$">
                  <b-form-input md=12 type="number" id="ph_refund_price" v-model="model.refund_price" :disabled="lock"></b-form-input>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <hr>
          <b-row>
            <b-col md="3">
              <b-form-group label="Payment Status" label-for="ph_is_paid" v-b-tooltip.hover title="payment status">
                <c-switch color="success" label size="sm" id="ph_is_refunded" v-model="model.is_paid" :disabled="lock" />
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group label="Payment Date" label-for="ph_paid_at" v-b-tooltip.hover title="payment Date">
                {{model.paid_at | datetime}}
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group label="Paid Amount" label-for="ph_total_paid" v-b-tooltip.hover title="payment Amount">
                <b-input-group md=12 prepend="$">
                  <b-form-input type="number" id="ph_total_paid" v-model="model.total_paid" :disabled="lock"></b-form-input>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group label="Billing Amount" label-for="ph_total_price" v-b-tooltip.hover title="Billing Amount">
                <b-input-group md=12 prepend="$">
                  <b-form-input type="number" id="ph_total_price" v-model="model.total_price" :disabled="lock"></b-form-input>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col md="4">
              <b-form-group label="Public Price" label-for="ph_base_price" v-b-tooltip.hover title="payment status">
                <b-input-group md=12 prepend="$">
                  <b-form-input v-model="model.discount_price" placeholder="0.00" type="number" :disabled="lock"></b-form-input>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group label="Discount Amount" label-for="ph_discount_price" v-b-tooltip.hover title="payment status">
                <b-input-group md=12 prepend="$">
                  <b-form-input v-model="model.discount_price" placeholder="0.00" type="number" :disabled="lock"></b-form-input>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group label="Service Unit in this Billing" label-for="ph_service_unit" v-b-tooltip.hover title="payment status">
                <b-input-group md=12 append="EA">
                  <b-form-input type="number" id="ph_service_unit" v-model="model.service_unit" :disabled="lock"></b-form-input>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <hr>
          <!-- 제공 서비스 -->
          <b-row v-if="model.service">
            <b-col md="3">
              <b-form-group label="Service Name" label-for="ph_service_name" v-b-tooltip.hover title="payment status">
                <b-input-group md=12>
                  <b-form-input v-model="model.service.service_name" type="text" :disabled="lock"></b-form-input>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group label="Cost Price" label-for="ph_service_base_price" v-b-tooltip.hover title="Cost price about service production">
                <b-input-group md=12 prepend="$">
                  <b-form-input v-model="model.service.base_price"  type="number" :disabled="lock"></b-form-input>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group label="Customer Price" label-for="ph_service_customer_price" v-b-tooltip.hover title="Customer price about service production">
                <b-input-group md=12 prepend="$">
                  <b-form-input v-model="model.service.customer_price"  type="number" :disabled="lock"></b-form-input>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group label="Partner Price" label-for="ph_service_partner_price" v-b-tooltip.hover title="Partner sale price about service production">
                <b-input-group md=12 prepend="$">
                  <b-form-input v-model="model.service.partner_price"  type="number" :disabled="lock"></b-form-input>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <hr>
          <!-- 부분 결제가 있을 경우 히스토리 내역 필요 -->
          <b-row>
            <b-col md="12">
              <label for=""><h4>Partial Payment History</h4></label>
            </b-col>
            <hr>
            <b-col md="12">
              <!-- TODO : 테이블로 예쁘게 해야 함 -->
              <ul class="list-group">
                <li class="list-group-item" v-for="item in payment_history" v-bind:key="item.id" v-bind:class="{ strong: item.hp > 300 }">
                  <p v-if="item && item.payer">
                    <!-- paypal -->
                    <!-- {{item}} -->
                    [Purchased Date:{{item.purchase_units[0].payments.captures[0].create_time | datetime}}]
                    [Company:{{item.payer.email_address}}]
                    [Action:{{item.purchase_units[0].description}}]
                    [Method:{{item.pg}}]
                    [price:{{item.purchase_units[0].amount.value}}]
                    [Currenty:{{item.purchase_units[0].amount.currency_code}}]
                    [Country:{{item.payer.address.country_code}}]
                  </p>
                  <p v-else>
                    <!-- boot_pay or credit -->
                    [Purchased Date:{{item.purchased_at | datetime}}]
                    [Company:{{item.pg_name}}]
                    [Action:{{item.action}}]
                    [Method:{{item.pg}}]
                    [price:{{item.price}}]
                    [Currenty:{{'KRW'}}]
                    [Country:{{'KR'}}]
                    <!-- country_code, currency_code -->
                  </p>
                </li>
              </ul>
            </b-col>
          </b-row>
          <!-- <b-button v-if="!lock" size="sm" variant="success" @click="save"> Save </b-button>
          <b-button v-else size="sm" variant="warning" @click="edit">Edit </b-button> -->
          <!-- <b-button v-if="!lock" size="sm" variant="info" @click="cancel"> Cancel </b-button> -->
          <!-- <b-button size="sm" variant="danger" @click="confirm = true;" v-if="model.id && lock"> Remove </b-button> -->
          <hr>
          <b-button size="sm" class="float-right" variant="primary" @click="list"> List </b-button>
        </b-card>
      </b-col>
    </b-row>

    <router-view></router-view>
    <!-- modal area -->
    <!-- <b-modal title="Remove"  class="modal-danger" v-model="confirm" @ok="remove" ok-variant="danger">
      If this group have user, can't log in after removed
      <br>
      Check first, this  group's user
      <br>
      Would You Like to Remove the group?
    </b-modal> -->
  </div>
</template>

<script>
import { Api } from '@/service';
import codes from '@/codes';
import reg from '@/reg';
import vSelect from 'vue-select';
import { Switch as cSwitch } from '@coreui/vue';

export default {
  components: {
    cSwitch,
    vSelect,
  },
  data : () => {
    return {
      so : {
        perPage: 15,
        currentPage: 1, totalRows: 0,
        sk: 'service.name', sv: '', skt: 'Service', opt : {}
      },
      add : false,
      reg,
      confirm : false,
      model : { group : {}, partner : {} },
      lock : true,
      codes,
      // group with partner
      chainPartner : false,
      syncPartner : false,
      passPartner : false,
      // 일부 거래 기록
      payment_history : []
    }
  },
  computed: {},
  methods: {
    edit:function() { this.lock = false },
    cancel: function() {
      if(this.$route.params.id == "add") { this.list(); }
      this.lock = true
      this.$emit('refresh')
    },
    list: function() { this.$router.push({ name: 'payment' }); this.$emit('refresh'); },
    remove: function() {
      Api.Manager_Call('payment', 'delete', { id : this.model.id })
        .then((rs) => {
          if(!rs.error) {
            this.$toastr.s('removed.', this.$route.name);
          } else {
            console.log("remove", 'failed', rs.reason, this.model.id)
            return this.$toastr.e('delete', "failed")
          }
          this.list();
        }).catch(e => (this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText), this.list()));
    },
    getRowCount () { return this.so.totalRows || 0; },
    async partnerSave() {
      try {
        this.model.partner_id = this.model.partner.id;

        let rs = await Api.Manager_Call('payment', 'update', Object.assign({}, this.model, { partner : {} }, this.region));
        if(!rs.error) {
          this.$toastr.s('Saved', this.$route.name);
          this.refresh(rs.body.id);
        } else {
          this.$toastr.e('Save', "failed"); this.refresh();
        }
        this.syncPartner = false;
      } catch (e) { console.log(e); this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText); }
    },
    save: async function() {
      try {
        if(!(this.model.groupname || '').trim()) { return this.$toastr.e('Group Name is Require.'); }
        if(!(this.model.service || '').trim()) { return this.$toastr.e('Service is Require.'); }
        if(!(this.model.email || this.model.contact || '').trim()) { return this.$toastr.e('email or contact is Require.'); }
        if(!(this.model.address || '').trim()) { return this.$toastr.e('address is Require.'); }
        // if(!this.model.partner && !this.model.partner_id) { return this.$toastr.e('partner is Require.'); }

        let rs = await Api.Manager_Call('payment', this.model.id ? 'update' : 'insert', Object.assign({}, this.model));
        if(!rs.error) {
          this.$toastr.s('Saved', this.$route.name);
          this.refresh(rs.body.id)
        } else {
          this.$toastr.e('Save', "failed"); this.list();
        }
        this.lock = true;
        this.refresh()
      } catch(e) { console.log(e); this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText); this.list()}
    },
    get: async function({ id, tag } = this.$route.params) {
      console.log('payment.detail.vue', 'load item', id);
      if(id === 'add' || tag === 'add') { this.model.is_verified = true; this.add = (tag != 'payment'); this.lock = false; return; }
      else {
        Api.Manager_Call('payment','detail',{ id : id })
          .then(rs => {
            if(rs.error) { return this.$toastr.e("load faild", this.$route.name); }
            this.model = Object.assign({}, this.model, rs.body)
            if(this.model.history) {
              this.payment_history = []
              this.model.history.forEach(r => this.payment_history.push(JSON.parse(r)));
            }
          })
          .catch(e => (this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText), this.list()));
      }
    },
    refresh(id) {
      this.$router.push({ name: 'payment', params : { id : id ? id : this.$route.params.id } }); this.$emit('refresh');
    }
  },
  watch: { '$route' (to, from) { console.log("from", from); this.get(to.params); } },
  created: function() { console.log('payment.detail.vue', 'created'); },
  destroyed: function() { console.log('payment.detail.vue', 'destroyed'); },
  mounted: function() {
    console.log('payment.detail.vue', 'mounted');
    this.get(this.$route.params);
  },
}
</script>
